// extracted by mini-css-extract-plugin
export var active = "_8i-b";
export var activeIndicator = "_8i-6";
export var animate = "_8i-a";
export var disabled = "_8i-c";
export var flat = "_8i-1";
export var fullWidth = "_8i-3";
export var lg = "_8i-9";
export var md = "_8i-8";
export var redoButtonTabGroup = "_8i-0";
export var sm = "_8i-7";
export var tabButton = "_8i-4";
export var tabButtonsContainer = "_8i-2";
export var xs = "_8i-5";